// Sidor som kräver inloggning. Den som inte är inloggad skickas till
// inloggningen och tillbaka hit efteråt. En byrå som inte har godkänt
// villkoren och biträdesavtalet får göra det först (ADR 0100).
import type { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router';
import { useAuth } from '../auth/auth.js';
import { GodkannAvtal } from '../pages/avtal/GodkannAvtal.js';

export function KraverInloggning({ children }: { children: ReactNode }) {
  const { inloggning, loggaUt } = useAuth();
  const plats = useLocation();

  switch (inloggning.status) {
    case 'inloggad':
      return inloggning.me.agreementsAccepted ? children : <GodkannAvtal />;
    case 'utloggad': {
      const till = plats.pathname + plats.search;
      return (
        <Navigate
          to={till === '/' ? '/logga-in' : `/logga-in?till=${encodeURIComponent(till)}`}
          replace
        />
      );
    }
    case 'laddar':
      return (
        <div className="laddar" role="status">
          Loggar in …
        </div>
      );
    case 'ingen-byra':
      return (
        <Problem titel="Kontot hör inte till någon byrå">
          <p>Be byråns ägare att bjuda in dig, eller logga in med ett annat konto.</p>
          <button type="button" className="btn btn-s" onClick={loggaUt}>
            Logga ut
          </button>
        </Problem>
      );
    case 'fel':
      return (
        <Problem titel="Vi når inte LeadLedger just nu">
          <p>Kontrollera anslutningen och försök igen om en stund.</p>
          <button type="button" className="btn btn-p" onClick={inloggning.forsokIgen}>
            Försök igen
          </button>
        </Problem>
      );
  }
}

function Problem({ titel, children }: { titel: string; children: ReactNode }) {
  return (
    <main className="inloggning">
      <div className="kort inloggning-kort" role="alert">
        <h1>{titel}</h1>
        {children}
      </div>
    </main>
  );
}
